// extracted by mini-css-extract-plugin
export default {"card":"Card_card__hBkRy","card__profile":"Card_card__profile__ZJWsG"};